// extracted by mini-css-extract-plugin
export default {"privacyBlurb":"GwRKoWxB9T8Rm4RmV7Iw"};